export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8755.bc14f818.jpg";